import EastIcon from "@mui/icons-material/East";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import appstore from "../store/appstore";
const Subscribing = () => {
  const [isMobileview, setIsMobileView] = useState(false);
  const [showConfit, setShowConfict] = useState(false);
  const [email, setEmail] = useState("");
  const { isSubscribed, setSubscribeEmail } = appstore();
  const handleSubscribe = async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      toast.error("Please enter valid email");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/subscribers",
      headers: {
        "Content-Type": "application/json",
      },
      data: { email: email, page: "landing-page" },
    };
    try {
      const response = await axios.request(config);
      // setMostPlayed(response.data);

      localStorage.setItem("isSubscribed", email);
      toast.success("Subscribed !", { autoClose: 2000 });
      setSubscribeEmail(true);
      setShowConfict(true);
      setTimeout(() => {
        setShowConfict(false);
      }, 2000);
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  React.useEffect(() => {
    if (isSubscribed) {
      setShowConfict(false);
    }
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };

    window.addEventListener("resize", updateScreenWidth);
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  return !isSubscribed ? (
    <Box
      style={{
        position: isMobileview ? "fixed" : "relative",
        bottom: "0",
        width: "100%",
        background: "white",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignContent: "center",
        paddingTop: "20px",
      }}
    >
      <Box margin={"auto"}>To explore more, subscribe to Simulyst!</Box>
      <Box margin={"auto"} marginTop={"10px"} marginBottom={"35px"}>
        <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
          <OutlinedInput
            type={"text"}
            placeholder="Email ID"
            style={{
              width: "231px",
              borderRadius: "35px",
              background: "#EDEDED",
              border: "none",
            }}
            onKeyUp={(e) => {
              if (e.key == "Enter") {
                handleSubscribe();
                // }}
              }
            }}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            focused={false}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={"display the password"}
                  style={{ background: "#C789E4", color: "white" }}
                  onClick={() => {
                    handleSubscribe();
                  }}
                  edge="end"
                >
                  <EastIcon style={{ padding: "5px" }} />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Box>
    </Box>
  ) : (
    // : showConfit ? (
    //   <Box
    //     id="subscribed"
    //     style={{
    //       position: "fixed",
    //       bottom: "0",
    //       width: "60%",
    //       height: "70vh",
    //       right: "20%",
    //       zIndex: "999999",
    //       display: "flex",
    //       justifyContent: "center",
    //       alignItems: "center",
    //       // border: "1px solid #F5EAFA",
    //     }}
    //   >
    //     <img src={Gif} style={{ position: "absolute" }} />
    //     <Box
    //       style={{
    //         padding: "16px 40px",
    //         borderRadius: "12px",
    //         background: "#F5EAFA",
    //         color: "#C789E4",
    //       }}
    //     >
    //       Subscribed
    //     </Box>
    //   </Box>
    // ) :
    ""
  );
};

export default Subscribing;
